import { Link } from 'react-router-dom';

interface ErrorTenantPageProps {
  tenantSlug?: string;
  reason?: 'not_found' | 'no_access' | 'inactive';
}

export default function ErrorTenantPage({
  tenantSlug,
  reason = 'not_found'
}: ErrorTenantPageProps) {
  const getMessage = () => {
    switch (reason) {
      case 'not_found':
        return {
          title: 'Workspace no encontrado',
          description: `El workspace "${tenantSlug}" no existe o fue eliminado.`,
          action: 'Volver al inicio'
        };
      case 'no_access':
        return {
          title: 'Sin acceso',
          description: `No tienes permisos para acceder a este workspace.`,
          action: 'Volver al inicio'
        };
      case 'inactive':
        return {
          title: 'Workspace inactivo',
          description: `Este workspace se encuentra actualmente inactivo.`,
          action: 'Volver al inicio'
        };
      default:
        return {
          title: 'Error',
          description: 'Ha ocurrido un error inesperado.',
          action: 'Volver al inicio'
        };
    }
  };

  const message = getMessage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <svg
            className="mx-auto h-24 w-24 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>

        <h1 className="text-6xl font-bold text-gray-300 mb-4">
          {reason === 'not_found' ? '404' : reason === 'no_access' ? '403' : '503'}
        </h1>

        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {message.title}
        </h2>

        <p className="text-gray-600 mb-8">
          {message.description}
        </p>

        <Link
          to="/"
          className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          {message.action}
        </Link>

        <p className="mt-8 text-sm text-gray-400">
          ¿Crees que esto es un error? Contacta a{' '}
          <a
            href="mailto:soporte@lyrax.cl"
            className="text-blue-600 hover:text-blue-700"
          >
            soporte@lyrax.cl
          </a>
        </p>
      </div>
    </div>
  );
}
